export default {
  loading: false,
  loaded: false,
  _callbacks: [],
  _players: [],
  load(cb){
    this._addCallback(cb);
    if (this.loading)
      return;
    if (this.loaded)
      return cb();
    window.onYouTubePlayerAPIReady = this.onLoaded.bind(this);
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/player_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  },
  onLoaded()  {
    this.loaded = true;
    this.loading = false;
    this._callbacks.forEach((cb) => {
      cb();
    })
  },
  registerPlayer(pl){
    if (this._players.indexOf(pl) === -1)
      this._players.push(pl);
  },
  stopAll(except){
    this._players.forEach((pl) => {
      if (except && except !== pl)
        pl.stopVideo();
    })
  },
  _addCallback(cb)  {
    if (this._callbacks.indexOf(cb) === -1)
      this._callbacks.push(cb);
  }
};


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/js/utils/YTLoader.js